import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import RevokedLicensesList from "../components/license/RevokedLicensesList";

const RevokedLicensesListPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Revoked Licenses" />

        {/* RevokedLicensesList */}
        <RevokedLicensesList />
      </MasterLayout>
    </>
  );
};

export default RevokedLicensesListPage;
